import React, { useLayoutEffect } from 'react'
import { SignupFormBody } from './style'
import { SignupFormVerificationOption } from './components/signup-form-verification-option/SignupFormVerificationOption'
import { SignupFormConfirmation } from './components/signup-form-confirm/SignupFormConfirmation'
import { SignupFormPassword } from './components/signup-form-password/SignupFormPassword'
import { PersonalDetailsForm } from './components/personal-details-form/PersonalDetailsForm'
import { ESignupFormSteps } from '../../../../../types/enums/ESignupFormSteps'
import {
  AuthContainer,
  AuthFormBg,
  AuthFormContainer,
  AuthFormHeader,
  AuthFormSubtitle,
  AuthFormTitle,
} from 'pages/auth/style'
import { FormTypes } from 'types/enums/EFormTypes'
import { RootState, useAppSelector } from 'store/store'
import { LogoContainer } from '../success/style'
import { Loader } from 'shared/components/loader/loader'
import logo from '../../../../../assets/images/hjbc_logo.png'
import HamburgerMenu from 'shared/components/hamburger-menu/HamburgerMenu'

type Props = {
  baseUrl?: string
}

export const SignupForm = ({ baseUrl }: Props) => {
  const formStep = useAppSelector((state: RootState) => state.layout.formStep)
  const direction = useAppSelector(
    (state: RootState) => state.layout.language.direction,
  )
  const isLoading = useAppSelector((state: RootState) => state.layout.isLoading)

  const authFormTexts = useAppSelector(
    (state: RootState) => state.layout.authFormTexts,
  )
  useLayoutEffect(() => {
    window.scrollTo(0, 0)
  }, [formStep])

  const signupStep = () => {
    switch (formStep) {
      case ESignupFormSteps.verificationOption:
        return <SignupFormVerificationOption baseUrl={baseUrl} />
      case ESignupFormSteps.password:
        return <SignupFormPassword />
      case ESignupFormSteps.confirmation:
        return <SignupFormConfirmation />
      case ESignupFormSteps.personalDetails:
        return <PersonalDetailsForm />
      default:
        return <SignupFormVerificationOption baseUrl={baseUrl} />
    }
  }

  return (
    <>
      <AuthContainer
        formType={FormTypes.SIGN_UP_FORM}
        formStep={formStep}
        direction={direction}
      >
        <AuthFormContainer direction={direction}>
          <HamburgerMenu />
          <AuthFormBg isLoading={isLoading} formType={FormTypes.SIGN_UP_FORM}>
            <LogoContainer>
              <img
                style={{ width: '100px', height: 'auto' }}
                src={logo}
                alt="Logo"
              />
            </LogoContainer>
            <AuthFormHeader>
              <AuthFormTitle className="bold">
                {authFormTexts.title}
              </AuthFormTitle>
              <AuthFormSubtitle>{authFormTexts.subtitle}</AuthFormSubtitle>
            </AuthFormHeader>
            <Loader isLoading={isLoading} />
            <SignupFormBody>
              <>{signupStep()}</>
            </SignupFormBody>
          </AuthFormBg>
        </AuthFormContainer>
      </AuthContainer>
    </>
  )
}
